// extracted by mini-css-extract-plugin
export default {"pagination":"T-VFX","arrow":"eEx-O","page":"+yWrw","active":"cJ1m+"};